import { observer } from 'mobx-react-lite'
import { ContainerHeader, FullPageWrapper } from 'shared/ui'
import { useHubspotWorkflowsPageContext } from 'pages/hubspotWorkflows/context/hubspotWorkflowsPageContext'
import { HubspotWorkflowsList } from 'pages/hubspotWorkflows/ui/hubspotWorkflowsList'

export const AllWorkflows = observer(() => {
  const { pageLayoutStore } = useHubspotWorkflowsPageContext()
  const { titleIconProps, handleToggleCollapse } = pageLayoutStore

  return (
    <FullPageWrapper>
      <ContainerHeader
        title={'Hubspot workflows'}
        titleVariant={'heading-md'}
        titleIconProps={titleIconProps}
        titleIconAction={handleToggleCollapse}
        paddingLeft={20}
      />
      <HubspotWorkflowsList />
    </FullPageWrapper>
  )
})
